// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3GuUo","upload":"Small_upload__3SjNX","imageWrap":"Small_imageWrap__3xxYD","removeBtn":"Small_removeBtn__nAzvR"};